var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddPayee = function SvgAddPayee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Add_Payee_svg__a)",
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6 9.99c-1.29 0-2.5-.49-3.38-1.38-.9-.9-1.4-2.08-1.4-3.33s.5-2.46 1.4-3.33C5.13 1.06 6.33.57 7.61.57c1.28 0 2.48.49 3.38 1.38.9.9 1.4 2.08 1.4 3.33s-.5 2.44-1.4 3.33c-.91.89-2.11 1.38-3.38 1.38H7.6ZM7.53 1.9c-1.87.04-3.38 1.54-3.38 3.39 0 1.38.84 2.61 2.13 3.13.41.17.86.25 1.32.25.92 0 1.78-.35 2.44-1a3.34 3.34 0 0 0 .74-3.7 3.433 3.433 0 0 0-3.18-2.1h-.07v.03ZM14.06 17.03v-2.35h-2.38v-1.04h2.38V11.3h1.06v2.34h2.38v1.04h-2.38v2.35h-1.06ZM.07 18.11c.12-1.8.9-3.49 2.2-4.76l.05-.05-.06-.06a7.95 7.95 0 0 1 5.33-2.07c.41 0 .84.04 1.28.11-.24.46-.42.95-.54 1.45-.19-.09-.46-.11-.74-.11-3.15 0-5.79 2.41-6.05 5.5H.07v-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.59 19.43c-2.94 0-5.34-2.36-5.34-5.25s2.39-5.26 5.34-5.26c2.95 0 5.33 2.36 5.33 5.26s-2.39 5.25-5.33 5.25Zm0-9.43c-2.33 0-4.22 1.87-4.22 4.16s1.89 4.16 4.22 4.16 4.22-1.87 4.22-4.16S16.92 10 14.59 10Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Add_Payee_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.07 .57)",
    d: "M0 0h19.86v18.86H0z"
  })))));
};
export default SvgAddPayee;